import { useEffect, useState } from "react";
import { toast } from "sonner";
import { adminGet, adminPut } from "@/lib/adminApi";
import { capFirst } from "@/lib/profile";

export default function Visio() {
  const [reasons, setReasons] = useState([]);
  const [newReason, setNewReason] = useState("");

  useEffect(() => {
    adminGet("/visio").then((d) => setReasons(d.reasons)).catch(() => {});
  }, []);

  const save = async (list) => {
    try {
      await adminPut("/visio", { reasons: list });
      setReasons(list);
      toast("Motifs enregistrés — le menu « Choisissez votre motif… » du site suit cette liste.");
    } catch {
      toast("Une erreur est survenue.");
    }
  };

  const add = () => {
    if (!newReason.trim()) return;
    save([...reasons, capFirst(newReason.trim())]);
    setNewReason("");
  };

  const remove = (r) => save(reasons.filter((x) => x !== r));

  return (
    <div data-testid="admin-visio-module">
      <h2 className="rav-admin-h2">Visio</h2>
      <p className="rav-page-sub rav-admin-note">
        Les motifs proposés dans le menu « Choisissez votre motif… » des réservations. Les durées et les prix se règlent
        dans « 15 — Abonnements & offres » (Visio 30/45/60 min) et le planning dans « 09 — Rendez-vous ».
      </p>
      <div className="rav-admin-list">
        {reasons.map((r, i) => (
          <div key={r} className="rav-admin-row" data-testid={`visio-reason-${i}`}>
            <span className="rav-admin-row-label">{r}</span>
            <span className="rav-admin-row-actions">
              <button type="button" className="rav-text-link" data-testid={`visio-reason-delete-${i}`} onClick={() => remove(r)}>
                Retirer
              </button>
            </span>
          </div>
        ))}
      </div>
      <div className="rav-admin-form">
        <input className="rav-input" data-testid="visio-reason-new" placeholder="Nouveau motif…" value={newReason} onChange={(e) => setNewReason(capFirst(e.target.value))} />
        <button type="button" className="rav-secondary-button rav-session-btn rav-admin-create" data-testid="visio-reason-add" onClick={add}>
          Ajouter ce motif
        </button>
      </div>
    </div>
  );
}
